export const START_PHOTOSHOOT = 'START_PHOTOSHOOT'
export const SET_IS_PHOTO_CAPTURE_OPEN = 'SET_IS_PHOTO_CAPTURE_OPEN'
export const SET_CAPTURED_IMAGE = 'SET_CAPTURED_IMAGE'
export const SET_PHOTO_CAPTURE_WIZARD_STEP = 'SET_PHOTO_CAPTURE_WIZARD_STEP'
export const SET_WHOS_IN_THE_PHOTO = 'SET_WHOS_IN_THE_PHOTO'
export const SAVE_PHOTO = 'SAVE_PHOTO'
export const SET_IS_SHOW_PHOTO_OPEN = 'SET_IS_SHOW_PHOTO_OPEN'
export const IS_SHOW_PHOTO_OPEN = 'isShowPhotoOpen'
export const SHOW_PHOTO_URL = 'showPhotoUrl'
export const PHOTO_CAPTURE_WIZARD_STEP = 'photoCaptureWizardStep'
export const CAPTURED_IMAGE = 'capturedImage'
export const CAPTURED_IMAGE_TIME = 'capturedImageTime'
export const WHO_IS_IN_THE_PHOTO = 'whoIsInThePhoto'
export const IS_PHOTO_CAPTURE_OPEN = 'isPhotoCaptureOpen'
export const UPLOAD_SPEED_THRESHOLD_FOR_CAMERA = 5
export const SET_IS_CAMERA_ENABLED = 'SET_IS_CAMERA_ENABLED'
export const IS_CAMERA_ENABLED = 'isCameraEnabled'
